/**
 * A catalog row is expandable (shows the periods chevron) only when the
 * "Forward periods inline" setting is on, we're on Spot in "1 per code" mode,
 * and the code actually has more than one period to reveal.
 */
export function canExpandRow({
  forwardPeriodsInline,
  isForwardCurves,
  expandedData,
  periodCount
}: {
  forwardPeriodsInline: boolean;
  isForwardCurves: boolean;
  expandedData: boolean;
  periodCount: number;
}): boolean {
  return forwardPeriodsInline && !isForwardCurves && !expandedData && periodCount > 1;
}
